import { useState, useCallback } from 'react';

const STORAGE_KEY = 'sport_favorites';

function loadFavorites() {
  try {
    return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
  } catch {
    return new Set();
  }
}

function saveFavorites(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
}

export default function useFavorites() {
  const [favoriteIds, setFavoriteIds] = useState(() => loadFavorites());

  const toggleFavorite = useCallback((photoId) => {
    setFavoriteIds(prev => {
      const next = new Set(prev);
      if (next.has(photoId)) {
        next.delete(photoId);
      } else {
        next.add(photoId);
      }
      saveFavorites(next);
      return next;
    });
  }, []);

  return { favoriteIds, toggleFavorite };
}
